import { atom } from "recoil";

export const multiWithdrawalStore = atom({
	key: "multiWithdrawalStore",
	default: {
		loaded: false,
		multiAccount: {
			withdrawals: [],
			multiPlayers: [],
		},
		multiWithdrawals: {
			pagination: {
				current: 1,
				total: 0,
				totalPage: 0,
				count: 0,
			},
		},
		multiPlayers: {
			pagination: {
				current: 1,
				total: 0,
				totalPage: 0,
				count: 0,
			},
		},
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
